import React, { useState } from "react";

const Paginations = ({ total, size, onPageChange }) => {
  const totalPages = Math.ceil(total / size);
  const [currentPage, setCurrentPage] = useState(1);
  const [currentRange, setCurrentRange] = useState(1);

  const startPage = (currentRange - 1) * 10 + 1;
  const endPage = Math.min(startPage + 9, totalPages);

  const handlePageChange = (page) => {
    if (page < 1 || page > totalPages) return;
    setCurrentPage(page);
    onPageChange(page);

    if (page > endPage) {
      setCurrentRange((prev) => prev + 1);
    } else if (page < startPage) {
      setCurrentRange((prev) => prev - 1);
    }
  };

  return (
    <div>
      <div className="d-flex align-items-center gap-2">
        <button
          className={`page-link circular-pagination ${currentPage === 1 ? "active" : ""}`}
          onClick={() => handlePageChange(1)}
          disabled={currentPage === 1}
        >
          1
        </button>

        {startPage > 1 && (
          <button
            className="page-link circular-pagination"
            onClick={() => setCurrentRange((prev) => prev - 1)}
          >
            ...
          </button>
        )}

        {[...Array(totalPages)].map((_, index) => {
          const pageNumber = index + 1;
          if (pageNumber === 1 || pageNumber === totalPages) return null;
          
          return (
            <button
              key={pageNumber}
              className={`page-link circular-pagination ${
                currentPage === pageNumber ? "active" : ""
              }`}
              onClick={() => handlePageChange(pageNumber)}
              style={{
                display:
                  pageNumber >= startPage && pageNumber <= endPage
                    ? "flex"
                    : "none",
              }}
            >
              {pageNumber}
            </button>
          );
        })}

        {endPage < totalPages && (
          <button
            className="page-link circular-pagination"
            onClick={() => setCurrentRange((prev) => prev + 1)}
          >
            ...
          </button>
        )}

        <button
          className={`page-link circular-pagination ${currentPage === totalPages ? "active" : ""}`}
          onClick={() => handlePageChange(totalPages)}
          disabled={currentPage === totalPages}
        >
          {totalPages}
        </button>
      </div>
    </div>
  );
};

export default Paginations;